import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Helper } from '../../../helpers/helper';
import { AlertasModales } from '../../../helpers/alertasModales';

declare const CKEDITOR: any;
@Component({
  selector: 'app-carta-saldo',
  templateUrl: './carta-saldo.component.html',
  styleUrls: ['./carta-saldo.component.css']
})
export class CartaSaldoComponent implements OnInit {
  @ViewChild('pdf') pdf: ElementRef;
  @ViewChild('bodyPdf') bodyPdf: ElementRef;
  @ViewChild('headerPdf') headerPdf: ElementRef;
  @ViewChild('footerPdf') footerPdf: ElementRef;
  form: FormGroup;
  isEditing = true;
  pdfContent: string;
  ckeditorHasErrror = false;
  imgFooter: string;
  date = new Date(this.helper.getDate());
  fecha = `${this.date.getDate()} de ${this.helper.monthNames[this.date.getMonth()]} de ${this.date.getFullYear()}`;
  loading = false;
  // tslint:disable-next-line:max-line-length
  constructor(private configuracionesService: ConfiguracionesService, private empleadoService: EmpleadosServicio, private render: Renderer, private helper: Helper, private modals: AlertasModales) {
    this.imgFooter = './assets/img/carta-footer.png';
    this.initForm();
  }

  ngOnInit() {
    const maxHeight = 792 - this.headerPdf.nativeElement.offsetHeight - this.footerPdf.nativeElement.offsetHeight;
    this.render.setElementStyle(this.pdf.nativeElement, 'height', '792pt');
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'height', `${maxHeight}pt`);
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'overflow', 'hidden');
    this.render.setElementStyle(this.bodyPdf.nativeElement, 'padding-right', '-10px');

    // Styles for footer pdf
    this.render.setElementStyle(this.footerPdf.nativeElement, 'padding', '0 2rem 3rem 2rem');
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-image', `url(${this.imgFooter})`);
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-repeat', 'no-repeat');
    this.render.setElementStyle(this.footerPdf.nativeElement, 'background-size', 'cover');
  }

  private initCkeditor() {
    CKEDITOR.replace('editor4', {
      height: 600
    });
  }

  private initForm(): void {
    this.form = new FormGroup({
      celular: new FormControl(''),
      telefono: new FormControl(''),
      empresa: new FormControl(''),
      direccion: new FormControl(''),
      modelo_html: new FormControl('', Validators.required)
    });

    this.initModelo();
  }

  private initModelo() {
    this.configuracionesService.modeloCartaSaldo()
    .subscribe((res: any) => {
      const form = this.form;
      if (res) {
        form.get('direccion').setValue(res.direccion);
        form.get('celular').setValue(res.celular);
        form.get('telefono').setValue(res.telefono);
        form.get('empresa').setValue(res.empresa);
        form.get('modelo_html').setValue(res.modelo_html);
        this.initCkeditor();
      } else {
        this.initCkeditor();
      }
    });
  }

  cartaPreview() {
    const ckeditorValue = CKEDITOR.instances.editor4.getData();
    if (!ckeditorValue) {
      this.ckeditorHasErrror = true;
      return false;
    }
    this.ckeditorHasErrror = false;
    this.isEditing = !this.isEditing;
    this.pdfContent = ckeditorValue;
  }

  actualizarConfiguracion() {
    if (!this.ckeditorHasErrror && !this.loading) {
      this.loading = true;
      this.form.get('modelo_html').setValue(CKEDITOR.instances.editor4.getData());

      this.configuracionesService.actualizarModeloCartaSaldo(this.form.value)
      .subscribe(res => {
        setTimeout(() => this.loading = false, 1);
        if (res) {
          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
        }
      }, err => {
        setTimeout(() => this.loading = false, 1);
        if (err) {
          if ((err.hasOwnProperty('status') && err.status === 0) ||
          (err.hasOwnProperty('name') && err.name === 'TimeoutError')) {
            this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
              'orange',
              'modern',
              false,
              'fa fa-wifi');
          } else {
            this.modals.validacionesModalJquery('Ha ocurrido un error inesperado', err, 'red', 'modern');
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/carta-saldo/carta-saldo.component.ts